export enum PaymentsStatus {
    charged = 'charged',
    refunds = 'refunds',
    pending = 'pending'
}
